// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7585":"/chunks/ComponentHomePageBlogPosts","9363":"/chunks/ComponentHomePageWhySuperHosting","9433":"/chunks/ComponentFooter"}[chunkId] + "." + {"7585":"401f8e81def4ecf750d2","9363":"dde87579e32cbf9f08d1","9433":"128c27c9d12ec7718489"}[chunkId] + ".css";
};